export const initialValues = {
  matrimonial_image: null,
  full_name: "",
  birth_date: null,
  marital_status: "",
  gender: "",
  matrimonial_document: null,
  is_active: 0,
  member_id: "",
  is_verified: 0,
};
